import { useState } from 'react';
import { faPlay } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { MediaGallery } from '@design-system/components/mediaGallery';
import { PostMediaItem } from '../model/post.types';

type Props = {
  media: PostMediaItem[];
};

export const PostMedia = ({ media }: Props) => {
  const [open, setOpen] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  if (media.length === 0) return null;

  const openAt = (index: number) => {
    setStartIndex(index);
    setOpen(true);
  };

  const single = media.length === 1;

  return (
    <>
      <div
        className={classNames(
          'flex gap-2.5 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]',
          single ? 'justify-center' : 'justify-start overflow-x-scroll',
        )}
      >
        {media.map((item, index) =>
          item.type === 'image' ? (
            <img
              key={item.url}
              src={item.url}
              loading="lazy"
              onClick={() => openAt(index)}
              className={classNames(
                'cursor-pointer rounded-[10px] object-cover',
                single ? 'max-h-[486px]' : 'max-h-[180px]',
              )}
            />
          ) : (
            <div
              key={item.url}
              onClick={() => openAt(index)}
              className="relative h-[180px] min-w-[118px] shrink-0 cursor-pointer"
            >
              <div className="absolute inset-0 grid place-items-center">
                <FontAwesomeIcon icon={faPlay} className="text-white" />
              </div>
              <video src={item.url} className="h-full w-full rounded-[10px]" />
            </div>
          ),
        )}
      </div>
      <MediaGallery
        open={open}
        items={media}
        startIndex={startIndex}
        onClose={() => setOpen(false)}
      />
    </>
  );
};
